//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { parseUniqueKey } from '../ReportCheckListUniqueKey.js'
import FilesField from '../../../../components/File/FilesField.vue'

export default {
  components: {
    FilesField
  },
  props: {
    resultName: {
      type: String,
      default: ''
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    technologicalOperation: {
      type: Object,
      required: true
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    }
  },
  data: function () {
    const filesProperty = this.resultValue.fieldType === 'image' ? 'guiImgFiles' : 'guiDocFiles'
    const filesGroupsContainer = this.report.filesGroupsContainers[filesProperty]

    return {
      filesGroup: filesGroupsContainer.getFilesGroup(this.resultValue.uniqueKey),
      rules: null, // @default
      singular: false, // @default
      warnings: [] // @default
    }
  },
  computed: {
    filesGroupToCheckForIgnoreDuplicate: function () {
      return this.report.filesGroupsContainers.guiImgFiles.getFilesGroup('other')
    }
  },
  methods: {
    onUploadSuccess: function ({ document, filesGroup, fileWrapper }) {
      if (!this.resultValue.value && this.singular) {
        this.resultValue.value = []
      }
      this.resultValue.value.push(document.id)

      this.onFinishUploadSuccess({ document, filesGroup, fileWrapper })
    },
    // @abstract
    onFinishUploadSuccess: function ({ document, filesGroup, fileWrapper }) {
    },
    onRemoveFile: async function ({ file, filesGroup }) {
      await filesGroup.removeFile(file)

      if (this.singular) {
        this.resultValue.value = []
      } else {
        this.resultValue.value = this.resultValue.value.filter(id => id !== file.id)
      }

      this.onFinishRemoveFile({ file, filesGroup })
    },
    // @abstract
    onFinishRemoveFile: function ({ document, filesGroup }) {
    },
    onFileAddToUpload: function (fileWrapper, filesGroup) {
      const filesGroupProps = filesGroup.props
      if (filesGroupProps) {
        fileWrapper.attributes = {
          resultKey: filesGroupProps.resultKey,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      }
    }
  }
}

